import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import MainLayout from '../layouts/MainLayout';
import { NotFound404 } from '../pages';
import { hasRouteAccess } from './rolePermissions';

interface Props {
  children: React.ReactNode;
  /** When false, render without app sidebar/header (full-page screens). */
  withLayout?: boolean;
}

// Wraps ProtectedRoute (auth) and adds role-based authorization.
// Allowed roles are resolved from the central rolePermissions map using
// the current path, so access rules live in one place.
const RoleRoute: React.FC<Props> = ({ children, withLayout = true }) => {
  const role = useSelector((state: any) => state.auth?.userDetails?.role);
  const { pathname } = useLocation();

  const content = hasRouteAccess(role, pathname) ? children : <NotFound404 />;

  return (
    <ProtectedRoute>
      {withLayout ? <MainLayout>{content}</MainLayout> : content}
    </ProtectedRoute>
  );
};

export default RoleRoute;
